module.exports = __webpack_public_path__ + "img/32.c4f63b56.jpg";